<template>
  <Modal title="分类" v-model="isShow" @on-cancel="handle">
    <div class="myModal">
        <Form ref="cateInfo"  :model='cateInfo' label-position="right" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
          <form-item label="分类名称" prop="title">
              <Input placeholder="请输入" v-model="cateInfo.title"></Input>
            </form-item>
          <FormItem label="分类图片(702*320)">
            <div class="demo-upload-list" v-for="item in uploadList" :key="item.url" >
              <template v-if="item.status === 'finished'">
                <img :src="item.url">
                <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                  <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                </div>
              </template>
              <template v-else>
                <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
              </template>
            </div>
            <Upload
              v-if="uploadList.length==0"
              ref="uploadThumb"
              :show-upload-list="false"
              :on-success="handleSuccess"
              :format="['jpg','jpeg','png']"
              :max-size="10240"
              :on-format-error="handleFormatError"
              :on-exceeded-size="handleMaxSize"
              :before-upload="handleBeforeUpload"
              type="drag"
              :action="serverApiPic"
              style="display: inline-block;width:58px;">
              <div style="width: 58px;height:58px;line-height: 58px;">
                <Icon type="ios-camera" size="20"></Icon>
              </div>
            </Upload>

            <Modal title="查看" v-model="visible">
              <img :src="server_url + imgUrl " v-if="visible" style="width: 100%">
            </Modal>
          </FormItem>
          <form-item label="排序" prop="sort">
            <InputNumber :min="0" v-model="cateInfo.sort"></InputNumber>
          </form-item>
          <form-item label="是否推荐首页：">
            <RadioGroup v-model="cateInfo.is_hot">
              <Radio :label="2" class="radio">是</Radio>
              <Radio :label="1">否</Radio>
            </RadioGroup>
          </form-item>
        </Form>
    </div>
    <div slot="footer">
        <Button type="primary"   @click="handleOk('cateInfo')" :loading="loading">
          <span v-if="!loading">提交</span>
          <span v-else>提交中...</span>
        </Button>
    </div>
  </Modal>
</template>
<style scoped>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
  .demo-upload-list{
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>
<script>
import { addCate, cateInfo } from '@/api/bookCate'
import Setting from '@/setting'
export default {
  name: 'categoryEdit',
  props: ['id'],
  data () {
    return {
      server_url: Setting.serverSrc,
      serverApiPic: Setting.serverApiPic,
      uploadList: [], // 缩咯图
      imgUrl: '',
      visible: false,
      pidArr: [],
      isShow: false,
      loading: false,
      category_id: 0,
      cateInfo: {
        id: 0,
        image: '',
        title: '',
        is_hot: 2,
        sort: 0,
        delpics: [] // 服务器待删除的照片
      },
      ruleValidate: {
        category_name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    id (val) {
      this.category_id = val
      if (this.category_id > 0) {
        this.getCateInfo()
      } else {
        this.cateInfo = {
          id: 0,
          image: '',
          title: '',
          sort: 0,
          delpics: [] // 服务器待删除的照片
        }
        this.uploadList = []
      }
    }
  },
  created () {
  },
  methods: {
    handle (status) {
      this.isShow = false
    },
    handleOk (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.uploadList.length <= 0) {
            this.$Message.error('分类图片必填')
            return
          }
          this.cateInfo.image = this.uploadList[0]['url']
          // console.log(this.cateInfo);return;
          this.loading = true
          addCate(this.cateInfo).then(res => {
            let msg = '添加成功'
            if (this.cateInfo.id > 0) {
              msg = '编辑成功'
            }
            if (res.code === 200) {
              this.$Message.success(msg)
              this.isShow = false
              this.$emit('updateStatusModel')
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },
    getCateInfo () {
      cateInfo(this.category_id).then(res => {
        this.cateInfo = res.data
        this.uploadList = []
        this.uploadList.push({ 'url': this.cateInfo.image, 'showProgress': false, 'percentage': 100, 'status': 'finished' })
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // getPid () {
    //   getPid().then(res => {
    //     this.pidArr = res.data
    //   }).catch(res => {
    //     this.$Message.error(res.msg)
    //   })
    // },
    handleView (url) {
      this.imgUrl = url
      this.visible = true
    },
    // 缩略图删除
    handleRemove (file) {
      const fileList2 = this.uploadList
      this.cateInfo.delpics.push(file.url)
      this.uploadList.splice(fileList2.indexOf(file), 1)
      this.uploadList = []
    },
    // 缩略图
    handleSuccess (res, file) {
      let file_url = res.data.file_url
      if (file_url.substring(0, 5) === 'https') {
        file.url = file_url
      } else {
        file.url = this.serverSrc + file_url
      }
      this.uploadList = this.$refs.uploadThumb.fileList
    },
    handleFormatError (file) {
      this.$Message.error('文件' + file.name + '格式错误，请上传jpg或者png')
    },
    handleMaxSize (file) {
      this.$Message.error('文件' + file.name + '太大，不能大于10M')
    },
    // 缩略图
    handleBeforeUpload () {
      const check = this.uploadList.length < 1
      if (!check) {
        this.$Message.error('只能上传1张图片')
      }
      return check
    }
  }
}
</script>
